import Link from "next/link";
import SearchIcon from "@mui/icons-material/Search";
import { slugify } from "@/utils/Common";
import { useRef } from "react";
import {
  trackSearchBarClicked,
  trackSearchResultClicked,
  getPageType,
} from "@/utils/gtmEvents";

const ProductSearch = (props) => {
  const {
    inputValue,
    isSearching,
    setIsSearching,
    data,
    handleInputChange,
    width,
    placeholder,
    transparentBg = false,
    recommendations = [], // Top products to show on click
    onSearchBarClick, // GTM tracking callback
    onResultClick, // GTM tracking callback
  } = props;
  const inputref = useRef(null);

  const focusOnInput = (event) => {
    inputref.current.focus();
    setIsSearching(true);

    // Track search bar click
    if (onSearchBarClick) {
      onSearchBarClick();
    }
  };

  const containerClasses = width
    ? `relative w-full`
    : `relative w-full max-w-[500px] sm:max-w-[400px] md:max-w-[500px] lg:max-w-[600px]`;

  const containerStyle = width ? { maxWidth: `${width}px` } : {};

  const searchBoxBgClass = transparentBg
    ? 'bg-white/20 backdrop-blur-sm border-white/30'
    : 'bg-white border shadow-sm';

  const inputTextClass = transparentBg
    ? 'text-white placeholder-white/70'
    : 'text-gray-900 placeholder-gray-500';

  return (
    <div className={containerClasses} style={containerStyle}>
      <div
        className={`
          ${searchBoxBgClass}
          relative
          h-[50px]
          flex
          justify-between
          items-center
          rounded-[8px]
          pl-4
          pr-0
          w-full
        `}
        onClick={focusOnInput}
      >
        <input
          type="text"
          ref={inputref}
          placeholder={placeholder || "Search by Products"}
          onChange={handleInputChange}
          onBlur={() =>
            setTimeout(() => {
              setIsSearching(false);
            }, 300)
          }
          className={`
            border-none
            outline-none
            w-[calc(100%-3.5rem)]
            py-2
            text-sm
            sm:text-base
            globalSearchInput
            bg-transparent
            ${inputTextClass}
          `}
        />
        <div
          className="
            w-[3rem]
            h-[3rem]
            bg-red
            rounded-[8px]
            flex
            justify-center
            items-center
            cursor-pointer
          "
        >
          <SearchIcon className="text-white" style={{ fontSize: "1.5rem" }} />
        </div>
      </div>

      {isSearching && (
        <div
          className="
            absolute
            z-[9999]
            w-full
            max-h-[50vh]
            overflow-y-auto
            bg-white
            shadow-lg
            rounded-b-[8px]
            border
            top-full
            left-0
          "
        >
          {/* Show search results if user has typed something */}
          {inputValue && data?.length > 0 ? (
            <div>
              {data?.map((e, index) => (
                <Link
                  href={`/product/${slugify(e?.ChemicalName)}-${e?.id}`}
                  onClick={() => {
                    if (onResultClick) {
                      onResultClick(e?.ChemicalName, index);
                    }
                    setIsSearching(false);
                  }}
                  key={e?.id}
                  className="
                    py-2
                    px-3
                    cursor-pointer
                    font-mukta
                    block
                    hover:bg-[#FFEBEA]
                    text-sm
                    sm:text-base
                  "
                >
                  <div className="w-full flex justify-between items-center">
                    <p className="truncate">
                      {`${e?.ChemicalName}  ${
                        e?.CasNumber ? `, ${e?.CasNumber}` : ""
                      }`}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          ) : inputValue && data?.length === 0 ? (
            <p
              className="
                p-3
                cursor-pointer
                font-mukta
                block
                text-gray-500
                text-center
                text-sm
                sm:text-base
              "
            >
              No Data Found
            </p>
          ) : !inputValue && recommendations?.length > 0 ? (
            /* Show recommendations when clicked but no input yet - same style as search results */
            <div>
              {recommendations.slice(0, 5).map((e, index) => (
                <Link
                  href={`/product/${slugify(e?.ChemicalName)}-${e?.id}`}
                  onClick={() => {
                    if (onResultClick) {
                      onResultClick(e?.ChemicalName, index);
                    }
                    setIsSearching(false);
                  }}
                  key={e?.id}
                  className="
                    py-2
                    px-3
                    cursor-pointer
                    font-mukta
                    block
                    hover:bg-[#FFEBEA]
                    text-sm
                    sm:text-base
                  "
                >
                  <div className="w-full flex justify-between items-center">
                    <p className="truncate">
                      {`${e?.ChemicalName}  ${
                        e?.CasNumber ? `, ${e?.CasNumber}` : ""
                      }`}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default ProductSearch;
